"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");
/**
 * @author VRu
 */


var TransactionType =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(TransactionType, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId the external id
   */
  function TransactionType(id, title, externalId) {
    var _this;

    _classCallCheck(this, TransactionType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionType).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return TransactionType;
}(CodebookItem_1.CodebookItem);

exports.TransactionType = TransactionType;
/** Name of code book for generic code book API. */

TransactionType.CODEBOOK_NAME = 'transactions.types';